import React, { useEffect, useRef, useState } from "react";
import RecordNotFound from "../../../../restaurant/shared/recordNotFound";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, formateDate, formatJapaneseMonthValue, get24HoursFormatedTime, globalLoader, handleServerValidations, RSUITE_DATE_FORMAT, showPrice, TrimText, useDebouncing } from "../../../../../utils/commonfunction";
import { EDIT_OPTIONS_LOAD_ERROR_KEY, LAZY_LOAD_SCROLL_OFFSET, LOADER_TIMEOUT_TIME, PAYMENT_METHOD_TYPES, PAYMENT_METHOD_TYPES_TRANSACTION, PAYMENT_OPTIONS_PARTIAL_ERROR_KEY, SWAL_SETTINGS, TRANSACTION_PRINT_TYPES } from "../../../../../utils/Constants";
import { buildSalesHistoryDateRangePayload, canEditMenuItem, createEmptySalesHistoryDateRange, getSalesHistoryDateRangeFromPicker, isSalesHistoryDateRangeComplete, isSalesHistoryDateRangeInvalid, mergeSalesPages } from "./salesHistory.helpers";
import SalesSlipViewModal from "../../../components/SalesSlipViewModal";
import { deleteTransactionSlip, editSalesSlipCashier, SalesHistoryData, transactionDetail } from "../../../services/sales.service";
import Swal from "sweetalert2";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { PaymentMethodList, list as TableList } from "../../../services/table.services";
import { staffList as StaffList } from "../../../services/auth.services";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../../restaurant/validator/validation";
import CustomError from "../../../../../utils/customError";
import DefaultProfileImg from "../../../../../assets/restaurant/images/default_user_profile.png";
import { useSelector } from "react-redux";
import { CustomProvider, DateRangePicker } from "rsuite";
import jaJP from "rsuite/locales/ja_JP";
import enUS from "rsuite/locales/en_US";
import zhCN from "rsuite/locales/zh_CN";

export default function SalesHistory() {
  const { t , i18n} = useTranslation();
  const RSUITE_LOCALES = {
    en: enUS,
    hi: enUS,
    ja: jaJP,
    ne: enUS,
    th: enUS,
    zh: zhCN,
  };
  const [List, setList] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [reservationDetail, setReservationDetail] = useState({});
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [transactionData, setTransactionData] = useState(null);
  const closeModalRef = useRef();
  const preserveEditValuesOnClose = useRef(false);
  const [itemPerPage] = useState(10);
  const printSlipRef = useRef();
  const [editModal, setEditModal] = useState(false);
  const { editSlipValidationSchema } = useValidationSchemas();
  const [staffArray, setStaffArray] = useState([]);
  const [tableListArray, setTableArrayList] = useState([]);
  const { validatePassword } = useValidationSchemas();
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [show, setShow] = useState("false");
  const isCashRegisterDone = useSelector((state) => state?.cashierDetails?.data);
  const openModal = useRef();
  const closePasswordRef = useRef();
  const [isDirty, setIsDirty] = useState(true)
  const [defaultOrderData, setDefaultOrderData] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const navigate = useNavigate();
  const [cardList , setCardList] = useState([]);
  const [otherPaymentList , setOtherPaymentList] = useState([]);
  const [editOptionsLoaded, setEditOptionsLoaded] = useState(false);
  const [editOptionsError, setEditOptionsError] = useState("");
  const [editOptionsLoading, setEditOptionsLoading] = useState(false);
  const [paymentOptionsWarning, setPaymentOptionsWarning] = useState("");
  const editOptionsLoadingRef = useRef(false);
  const [dateRange, setDateRange] = useState(createEmptySalesHistoryDateRange);
  const dateRangePickerRef = useRef();
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);

  const openEditAuthentication = () => {
    // The edit modal is being hidden only to show the password modal. Keep the
    // edited Formik values available for the authenticated save request.
    preserveEditValuesOnClose.current = true;
    closeModalRef.current.click();
    openModal.current.click();
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const prepareGlobalSearch = (value) => {
    setPage(1);
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    searchDebounce(value);
  };

  const loadEditOptions = async () => {
    if (editOptionsLoaded) {
      setEditOptionsError("");
      setPaymentOptionsWarning("");
      return true;
    }

    if (editOptionsLoadingRef.current) {
      return false;
    }

    editOptionsLoadingRef.current = true;
    setEditOptionsLoading(true);
    setEditOptionsError("");
    setPaymentOptionsWarning("");

    try {
      const [tablesResult, staffResult, cardsResult, othersResult] = await Promise.allSettled([
        TableList(),
        StaffList(),
        PaymentMethodList({ global_search: PAYMENT_METHOD_TYPES.CREDIT_CARD }),
        PaymentMethodList({ global_search: PAYMENT_METHOD_TYPES.QR_PAYMENTS }),
      ]);

      if (tablesResult.status === "rejected" || staffResult.status === "rejected") {
        if (tablesResult.status === "rejected") console.error(tablesResult.reason);
        if (staffResult.status === "rejected") console.error(staffResult.reason);
        setEditOptionsError(t(EDIT_OPTIONS_LOAD_ERROR_KEY));
        return false;
      }

      setTableArrayList(tablesResult.value?.data?.list || []);
      setStaffArray(staffResult.value?.data || []);

      let paymentFailed = false;
      if (cardsResult.status === "rejected") {
        console.error(cardsResult.reason);
        paymentFailed = true;
      } else {
        setCardList(cardsResult.value?.data?.list || []);
      }
      if (othersResult.status === "rejected") {
        console.error(othersResult.reason);
        paymentFailed = true;
      } else {
        setOtherPaymentList(othersResult.value?.data?.list || []);
      }
      if (paymentFailed) {
        setPaymentOptionsWarning(t(PAYMENT_OPTIONS_PARTIAL_ERROR_KEY));
      }

      setEditOptionsLoaded(true);
      return true;
    } finally {
      editOptionsLoadingRef.current = false;
      setEditOptionsLoading(false);
    }
  };

  useEffect(() => {
    const isFirstBatch = page === 1;
    if (isFirstBatch) {
      setLoader(true);
    } else {
      setLoadingMore(true);
    }
    const formData = new FormData();
    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify(search));
    }
    const dateRangePayload = buildSalesHistoryDateRangePayload(dateRange);
    Object.entries(dateRangePayload).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("global_search", globalSearch);
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    SalesHistoryData(formData)
      .then((data) => {
        const batch = data?.data?.list || [];
        setList((loaded) => (isFirstBatch ? batch : mergeSalesPages(loaded, batch)));
        setTotalRecords(data?.data?.total_records || 0);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      })
      .finally(() => {
        if (isFirstBatch) {
          setTimeout(() => {
            setLoader(false);
          }, LOADER_TIMEOUT_TIME);
        } else {
          setLoadingMore(false);
        }
      });
  }, [search, refreshList, globalSearch, page, dateRange]);

  // any refresh after an edit or delete starts again from the first batch
  const refreshSalesList = () => {
    setPage(1);
    setRefreshList((current) => !current);
  };

  // next batch loads when the table body is scrolled near its bottom
  const handleTableScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (loader || loadingMore || List.length >= totalRecords) {
      return;
    }
    if (scrollHeight - scrollTop - clientHeight <= LAZY_LOAD_SCROLL_OFFSET) {
      setPage((current) => current + 1);
    }
  };

  const getTransactionDetail = (o_id , printReceipt=false, type=TRANSACTION_PRINT_TYPES.RECEIPT) => {
    transactionDetail({ o_id: o_id , printReceipt :printReceipt, type: type})
      .then((response) => {
        setTransactionData(response && response.data ? response.data : []);
        setDefaultOrderData({
          transaction_id: response?.data?._id || "",
          number_of_persons: response?.data?.number_of_persons || 0,
          men: response?.data?.men || 0,
          women: response?.data?.women || 0,
          payment_method: response?.data?.payment_method || "",
          type: response?.data?.type || "",
          cashier_id: response?.data?.cashier_id?._id || "",
          table_id: response?.data?.tableDetail?._id || "",
        })
        if (printReceipt) {
          Swal.fire({ icon: "success", text: t("msg_reprint_queued"), ...SWAL_SETTINGS });
        }
      })
      .catch((error) => {
        console.log("error=====>", error);
        if (printReceipt) {
          Swal.fire({ icon: "error", text: t("msg_reprint_failed"), ...SWAL_SETTINGS });
        }
      });
  };


  const handleDelete = (_id) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteTransactionSlip({ _id: _id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              closeModalRef.current.click();
              refreshSalesList();
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch(() => {
            globalLoader(false);
          });
      }
    });
  };

  const addSlipChanges = useFormik({
    initialValues: {
      transaction_id: transactionData?._id || "",
      number_of_persons: transactionData?.number_of_persons || 0,
      men: transactionData?.men || 0,
      women: transactionData?.women || 0,
      payment_method: transactionData?.payment_method || "",
      type: transactionData?.type || "",
      cashier_id: transactionData?.cashier_id?._id || "",
      table_id: transactionData?.tableDetail?._id || "",
      method_name : transactionData?.method_name||"-", 
      payment_method_id : transactionData?.payment_method_id ||""
    },
    validationSchema: editSlipValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => formData.append(key, value));
      setSelectedStaff(isCashRegisterDone);

      try {
        if (values.type === "cancelled" && transactionData.type !== "cancelled") {
          Swal.fire({
            title: t("msg_are_you_sure"),
            text: t("cancel_sales_slip_text_"),
            imageUrl: trash,
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: t("btn_cancel_reservation"),
            cancelButtonText: t("false_label_no"),
            reverseButtons: true,
            customClass: {
              popup: "swal-restaurant",
              confirmButton: "btn btn-danger col",
              cancelButton: "btn btn-secondary col",
            },
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              openEditAuthentication();
            }
          });
        }
        else {
          openEditAuthentication();
        }


      } catch (error) {
        closeModalRef.current.click();
        setEditModal(false);
        console.error("Error adding table", error);
      }
    },
  });
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: validatePassword,
    onSubmit: async (values, { setSubmitting, resetForm }) => {


      try {
        const data = {
          ...addSlipChanges.values, 
          email: selectedStaff.email,
          password: values.password, 
        };

        if(addSlipChanges?.values?.payment_method!=='cash'){
  
          if(addSlipChanges?.values?.payment_method==='card'){
           
            cardList.forEach((item)=>{
              console.log(item ,data.method_name )
              if(item.payment_type===data.method_name){
                data.payment_method_id =item._id 
              }
               
            })
            
          }
          if(values?.payment_method==='other'){
           
            otherPaymentList.forEach((item)=>{
              if(item.payment_type===data.method_name){
                data.payment_method_id =item._id 
              }
               
            })
          }
        }


        const response = await editSalesSlipCashier(data);


        if (response.success) {
          refreshSalesList();
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          resetForm();
          addSlipChanges.resetForm();
        } else {
          refreshSalesList();
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
          resetForm();
          addSlipChanges.resetForm();
          setSubmitting(false)

        }
        closePasswordRef.current.click();
      } catch (error) {

        closePasswordRef.current.click();
        console.error("Error adding table", error);
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          text: error?.response?.data?.message || t("msg_invalid_password"),
          ...SWAL_SETTINGS,
        });
      }
    },
  });

  const handleshow = (event) => {
    setShow(!show);
  };

  const printReceipt = async (id)=>{
    getTransactionDetail(id , true, TRANSACTION_PRINT_TYPES.RECEIPT)
  }
  const printInvoice = async (id)=>{
    getTransactionDetail(id , true, TRANSACTION_PRINT_TYPES.ROYUSHU)
  }
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    setPage(1);
    setSearch({type : value}); // Update global search
  };

  const handleDateRangeChange = (value) => {
    if (!value) {
      clearDateRange();
      return;
    }

    const nextDateRange = getSalesHistoryDateRangeFromPicker(value);
    if (!isSalesHistoryDateRangeComplete(nextDateRange)) {
      return;
    }
    if (isSalesHistoryDateRangeInvalid(nextDateRange)) {
      Swal.fire({
        icon: "error",
        text: t("msg_invalid_date_range"),
        ...SWAL_SETTINGS,
      });
      return;
    }

    setPage(1);
    setDateRange(nextDateRange);
    setIsDateRangePickerOpen(false);
  };

  const clearDateRange = () => {
    setPage(1);
    setDateRange(createEmptySalesHistoryDateRange());
    setIsDateRangePickerOpen(false);
  };

  const dateRangeLabel = isSalesHistoryDateRangeComplete(dateRange)
    ? `${formateDate(dateRange.startDate)} - ${formateDate(dateRange.endDate)}`
    : t("placeholder_sales_history_date_range");
  const today = new Date();
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);
  const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
  const endOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59, 999);
  const lastSevenDaysStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
  const dateRangeShortcuts = [
    {
      label: "today",
      value: [startOfToday, endOfToday],
      placement: "bottom",
    },
    {
      label: "yesterday",
      value: [startOfYesterday, endOfYesterday],
      placement: "bottom",
    },
    {
      label: "last7Days",
      value: [lastSevenDaysStart, endOfToday],
      placement: "bottom",
    },
    {
      label: <span className="cashier-sales-history-clear-shortcut-label">{t("label_clear")}</span>,
      value: null,
      closeOverlay: true,
      placement: "bottom",
      className: "cashier-sales-history-clear-shortcut",
    },
  ];


  return (
    <div className="cashier-heading-innner mb-4">
      <div className="card-outer-header d-flex justify-content-between align-items-center">
        <h4 className="heading-title-text">{t("label_sales_history")} </h4>
        <div className="card-head-group d-flex align-items-center gap-4">
        <div style={{ position: "relative", display: "inline-block" }}>
          <button className="btn btn-date" onClick={() => {
            if (isDateRangePickerOpen) {
              dateRangePickerRef.current?.close?.();
            } else {
              dateRangePickerRef.current?.open?.();
            }
            setIsDateRangePickerOpen((current) => !current);
          }}>
            <i className="ti ti-calendar" style={{ color: "#757575" }}></i>{" "}
            <span style={{ color: "#757575" }}>{dateRangeLabel}</span>{" "}
            <i className={`ti ${isDateRangePickerOpen ? "ti-chevron-up" : "ti-chevron-down"}`} style={{ color: "#757575" }}></i>
          </button>
          <div
            style={{
              visibility: "hidden",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <CustomProvider locale={RSUITE_LOCALES[i18n.language]}>
              <DateRangePicker
                ref={dateRangePickerRef}
                classPrefix="restaurant"
                menuClassName="rs-restaurant-popup-date cashier-sales-history-popup-date"
                placement="bottomStart"
                container={() => document.body}
                format={RSUITE_DATE_FORMAT}
                cleanable={false}
                editable={false}
                ranges={dateRangeShortcuts}
                value={isSalesHistoryDateRangeComplete(dateRange) ? [dateRange.startDate, dateRange.endDate] : null}
                onChange={handleDateRangeChange}
                onToggle={setIsDateRangePickerOpen}
                disabledDate={(date) => date > new Date()}
                onClose={() => setIsDateRangePickerOpen(false)}
                locale={{
                  sunday: t("label_sunday_small"),
                  monday: t("label_monday_small"),
                  tuesday: t("label_tuesday_small"),
                  wednesday: t("label_wednesday_small"),
                  thursday: t("label_thursday_small"),
                  friday: t("label_friday_small"),
                  saturday: t("label_saturday_small"),
                  monthFormat: "MMMM yyyy",
                }}
                renderTitle={(date) => <span>{formatJapaneseMonthValue(date)}</span>}
              />
            </CustomProvider>
          </div>
        </div>
        <div className="tabls-dowpdown">
        <select className="form-control cp" value={selectedValue} onChange={handleChange}>
      <option disabled value="">
        {t("label_select_status")}
      </option>
      <option value="restaurant_order">{t("label_sales")}</option>
      <option value="cancelled">{t("label_cancelled")}</option>
    </select>
            </div>
          <div className="search-box">
            <input type="text" value={searchValue} className="form-control search-input  sales-history-input" placeholder={t("input_placeholder_search")} onChange={handleSearchChange} />
          </div>
        </div>
        <button data-bs-toggle="modal" data-bs-target="#modal-users-single1" style={{ display: "none" }} ref={openModal}></button>
      </div>

      <div className="dashboard-content-wraper mt-4">
        <div className="category-list-wrap">
          {loader ? (
            <div className="w-100">
              <Skeleton className="mb-2" height={50} count={5} />
            </div>
          ) : List?.length ? (
            <div className="card">
              <div className="card-body">
                <div className="table-responsive sales-history-scroll" onScroll={handleTableScroll}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>{t("s_no")}</th>
                        <th> {t("label_table_number")} </th>
                        <th> {t("input_placeholder_date")}</th>
                        <th>{t("label_time")}</th>
                        <th>{t("label_total_amount")}</th>
                        <th>{t("label_choose_payment_method")}</th>
                        <th>{t('label_status')}</th>
                        <th style={{ width: "150px" }}>{t("label_action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {List.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{TrimText(item?.tableDetail?.table_number, 15)|| t("label_not_entered")}</td>
                            <td>{formateDate(item?.createdAt)}</td>
                            <td>{get24HoursFormatedTime(item?.createdAt)}</td>
                            <td> ¥ {showPrice(item?.amount_after_discount || 0, 3)}</td>
                            <td>{capitalizeFirstLetter(t(`label_${item?.payment_method}` )|| t("label_not_entered"))}</td>

                            <td> {item.type==="restaurant_order"?t('label_sales'): t("label_cancelled")}</td>

                            <td className="d-flex">
                              <a
                                className="btn btn-primary "
                                data-bs-toggle="modal"
                                data-bs-target="#open-modal"
                                onClick={() => {
                                  getTransactionDetail(item?._id);
                                }}
                                style={{ width: "120px" }}
                              >
                                {t("btn_view")}
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {loadingMore ? (
                    <div className="d-flex justify-content-center py-3">
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">{t("loading")}</span>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="table-status-info d-flex justify-content-between align-items-center">
                  <span>
                    {t("label_showing")} {List.length} of {totalRecords} {t("label_entries")}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <RecordNotFound heading="lbl_record_not_found" />
          )}
        </div>
      </div>

      <div className="modal fade " data-bs-backdrop="static" id="open-modal" tabIndex="-1" aria-labelledby="sort-modalLabel" aria-hidden="true">
        {/* <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"> */}
        {!editModal === true ? (
          <SalesSlipViewModal
            mode="full"
            transactionData={transactionData}
            closeModalRef={closeModalRef}
            printSlipRef={printSlipRef}
            canEditSales={transactionData?.source !== "bulk_settlement"}
            editOptionsLoading={editOptionsLoading}
            editOptionsError={editOptionsError}
            onEditSales={async () => {
              if (await loadEditOptions()) {
                setEditModal(true);
              }
            }}
            showEditMenu={canEditMenuItem(transactionData)}
            onEditMenu={() => {
              navigate(`/cashier/dashboard/categories/${transactionData._id}?type=edit-sales`)
              closeModalRef.current.click();
            }}
            onPrintReceipt={() => { printReceipt(transactionData?._id) }}
            onPrintInvoice={() => { printInvoice(transactionData?._id) }}
          />
        ) : (
          <form onSubmit={addSlipChanges.handleSubmit}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable  ">
              <div className="modal-content" style={{ borderRadius: "10px" }}>
                <div className="modal-header d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-icon"
                    onClick={() => {
                      setEditModal(false);
                      setIsDirty(true);
                      addSlipChanges.resetForm();
                    }}
                  >
                    <i className="ti ti-arrow-left"></i>
                  </button>
                  <h1 className="modal-title fs-5 text-center w-100" id="exampleModalLabel">
                    {t('label_slip_number')} : {String(transactionData?.slip_number)?.padStart(4, "0") || ""}
                  </h1>
                  <button
                    type="button"
                    className="btn btn-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    id="close_modal"
                    ref={closeModalRef}
                    onClick={() => {
                      setEditModal(false);
                      setIsDirty(true);
                      if (preserveEditValuesOnClose.current) {
                        preserveEditValuesOnClose.current = false;
                      } else {
                        addSlipChanges.resetForm();
                      }
                    }}
                  >
                    <i className="ti ti-x"></i>
                  </button>
                </div>

                <div className="modal-body p-0" ref={printSlipRef}>
                  <div className="sales-slip-details-box">
                    <div className="sales list-info" style={{ width: "100%", borderRight: "none" }}>
                      <ul>
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_person_in_charge")}</span>
                          </div>
                          <div className="list-info-right">
                            <select className="form-control cp" name="cashier_id" value={addSlipChanges.values.cashier_id} onChange={(e) => { addSlipChanges.handleChange(e); setIsDirty(false) }} onBlur={addSlipChanges.handleBlur}>
                              {staffArray?.map((item, index) => {
                                return (
                                  <option value={item?._id} key={index} selected={transactionData.cashier_id?._id === item?._id ? true : false}>
                                    {TrimText(item.name, 25)}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </li>
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_table_no")}</span>
                          </div>
                          <div className="list-info-right">
                            <select className="form-control cp" name="table_id" value={addSlipChanges?.values?.table_id} onChange={(e) => { addSlipChanges.handleChange(e); setIsDirty(false) }} onBlur={addSlipChanges.handleBlur}>
                              {tableListArray?.map((item, index) => {
                                return (
                                  <option value={item?._id} key={index} selected={transactionData?.tableDetail?._id === item?._id ? true : false}>
                                    {item?.table_number}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </li>
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_no_of_people")}</span>
                          </div>
                          <div className="list-info-right">
                            <div className="d-flex flex-column gap-2 men-women-input-edit">
                              <div className="form-group d-flex align-items-center gap-2">
                                <label> {t("label_all")} </label>
                                <span>
                                  {/* : {transactionData?.number_of_persons || 0} */}
                                  <input
                                    type="number"
                                    className="form-control no_spring_input"
                                    name="number_of_persons"
                                    value={addSlipChanges?.values?.number_of_persons}
                                    onChange={(e) => {
                                      setIsDirty(false);
                                      addSlipChanges.handleChange(e);
                                    }}
                                    onBlur={addSlipChanges.handleBlur}
                                  />
                                </span>
                              </div>
                              <div className="form-group d-flex align-items-center gap-2">
                                <label>{t("men")}</label>
                                <input
                                  type="number"
                                  className="form-control no_spring_input"
                                  name="men"
                                  value={addSlipChanges?.values?.men}
                                  onChange={(e) => {
                                    setIsDirty(false);
                                    addSlipChanges.handleChange(e);
                                    if (e.target.value && !isNaN(e.target.value)) {
                                      const value = Number(e.target.value);
                                      const totalValue = addSlipChanges?.values?.number_of_persons;
                                      const finalValue = totalValue - value;
                                      if (finalValue >= 0) {
                                        addSlipChanges.setFieldValue("women", totalValue - value);
                                      } else {
                                        addSlipChanges.setFieldValue("women", 0);
                                      }
                                    }
                                  }}
                                  onBlur={addSlipChanges.handleBlur}
                                />

                                {/* <input type='text' className='form-control'/> */}
                              </div>
                              <div className="form-group d-flex align-items-center gap-2">
                                <label>{t("women")}</label>
                                <input
                                  type="number"
                                  className="form-control no_spring_input"
                                  name="women"
                                  value={addSlipChanges?.values?.women}
                                  onChange={(e) => {
                                    addSlipChanges.handleChange(e);
                                    setIsDirty(false)
                                    if (e.target.value && !isNaN(e.target.value)) {
                                      const value = Number(e.target.value);
                                      const totalValue = addSlipChanges?.values?.number_of_persons;
                                      const finalValue = totalValue - value;
                                      if (finalValue >= 0) {
                                        addSlipChanges.setFieldValue("men", totalValue - value);
                                      } else {
                                        addSlipChanges.setFieldValue("men", 0);
                                      }
                                    }
                                  }}
                                  onBlur={addSlipChanges.handleBlur}
                                />
                              </div>
                            </div>
                            <CustomError name="men" form={addSlipChanges} className="text-danger" />
                            <CustomError name="women" form={addSlipChanges} className="text-danger" />
                            <CustomError name="number_of_persons" form={addSlipChanges} className="text-danger" />
                          </div>
                        </li>
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_choose_payment_method")}</span>
                          </div>
                          <div className="list-info-right">
                            <select
                              className="form-control cp"
                              name="payment_method"
                              value={addSlipChanges.values.payment_method}
                              onChange={(e) => { addSlipChanges.handleChange(e); setIsDirty(false) }}
                              onBlur={addSlipChanges.handleBlur}
                            >
                              {PAYMENT_METHOD_TYPES_TRANSACTION.map((item, index) => {
                                return (
                                  <option value={item.value} key={index} selected={transactionData.payment_method === item.value ? true : false}>
                                    {t(item.label)}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </li>
                        {addSlipChanges?.values?.payment_method!=="cash"&&
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_method_name")}</span>
                          </div>
                          <div className="list-info-right">
                            <select
                              className="form-control cp"
                              name="method_name"
                              value={addSlipChanges.values.method_name}
                              onChange={(e) => { addSlipChanges.handleChange(e); setIsDirty(false) }}
                              onBlur={addSlipChanges.handleBlur}
                            >
                                  {addSlipChanges?.values?.payment_method==="card"?
                                cardList.map((item, index) => {
                                  return (
                                    <option value={item.payment_type} key={index} selected={addSlipChanges.values.payment_method === item.value ? true : false}>
                                      {t(item.payment_type)}
                                    </option>
                                  );
                                }):
                                otherPaymentList.map((item, index) => {
                                  return (
                                    <option value={item.payment_type} key={index} selected={addSlipChanges.values.payment_method === item.value ? true : false}>
                                      {t(item.payment_type)}
                                    </option>
                                  );
                                })
                              
                              }
                            </select>
                          </div>
                        </li>}
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_date_time")}</span>
                          </div>
                          <div className="list-info-right">
                            <span>{formateDate(transactionData?.createdAt, "YYYY/MM/DD", true, false)}</span>
                          </div>
                        </li>
                        <li>
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_type")}</span>
                          </div>
                          <div className="list-info-right">
                            <select className="form-control" name="type" value={addSlipChanges.values.type} onChange={(e) => { addSlipChanges.handleChange(e); setIsDirty(false) }} onBlur={addSlipChanges.handleBlur}>
                              <option value="restaurant_order" selected={transactionData.type === "restaurant_order" ? true : false}>
                                {t("label_sales")}
                              </option>
                              <option value="cancelled" selected={transactionData.type === "cancelled" ? true : false}>
                                {t("label_cancelled")}
                              </option>
                            </select>
                          </div>
                        </li>
                        <li className="list-border-none">
                          <div className="list-info-left">
                            <span style={{ fontSize: "18px", fontWeight: 600, color: "black" }}>{t("label_sales")}</span>
                          </div>
                        </li>
                        <li className="list-border-none">
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_sub_total")}</span>
                          </div>
                          <div className="list-info-right">
                            <span>¥ {showPrice(transactionData?.subtotal)} </span>
                          </div>
                        </li>
                        <li className="list-border-none">
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_discount_if_applicable")}</span>
                          </div>
                          <div className="list-info-right">
                            <span>
                              {transactionData?.gift_card_applied || transactionData?.coupon_applied
                                ? `¥ ${showPrice(transactionData?.great_grand_total - transactionData?.amount_after_discount)}`
                                : 0}
                            </span>
                          </div>
                        </li>
                        <li className="list-border-none">
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_consumption_tax")}</span>
                          </div>
                          <div className="list-info-right">
                            <span>¥ {showPrice(transactionData?.tax_price || 0)}</span>
                          </div>
                        </li>
                        {transactionData?.service_charge  > 0 &&
                         <li className="list-border-none">
                         <div className="list-info-left">
                           <span style={{ color: "black" }}>{t("service_charge")}</span>
                         </div>
                         <div className="list-info-right">
                           <span>¥ {showPrice(transactionData?.service_charge || 0)}</span>
                         </div>
                       </li>

                        }
                       
                        <li className="list-border-none">
                          <div className="list-info-left">
                            <span style={{ color: "black" }}>{t("label_total_capitalize")}</span>
                          </div>
                          <div className="list-info-right">
                            <span>
                              <b>¥ {showPrice(transactionData?.amount_after_discount || 0, 3)}</b>
                            </span>
                            <br></br>
                            <span>
                              8% {t("tax_on_text")} ¥ {showPrice(transactionData?.taxable_amount_8)}
                            </span>
                            <br></br>
                            <span>
                              10% {t("tax_on_text")} ¥ {showPrice(transactionData?.taxable_amount_10)}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className='p-3'>
                                  <textarea className='form-control' style={{ height: '100px' }} placeholder='Comments'></textarea>
                              </div> */}
                </div>
                <div className="modal-footer justify-content-center">
                  <button type="submit" className="btn btn-primary" style={{ width: "850px" }} disabled={isDirty || (JSON.stringify(defaultOrderData) === JSON.stringify(addSlipChanges?.values))}>
                    {t("btn_save_changes")}
                  </button>
                  {paymentOptionsWarning && <div className="text-warning w-100 text-center mt-2">{paymentOptionsWarning}</div>}
                </div>
              </div>
            </div>
          </form>
        )}
        {/* </div> */}
      </div>

      {/* model for authenticate the user  */}

      <div className="modal fade modal-cashier" id="modal-users-single1" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between">

              <h1 className="modal-title fs-5 text-center w-100" id="exampleModalLabel">
                {t("label_authenticate_user")}
              </h1>
              <button
                type="button"
                className="btn btn-icon"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closePasswordRef}
                onClick={() => {
                  // Leaving the authentication step discards the pending edit, so the
                  // values preserved for the save request must not survive the modal.
                  formik.resetForm();
                  addSlipChanges.resetForm();
                }}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="user-enter-password ">
                <div className="list-user-box">
                  <figure className="avatar avatar-md">
                    <img src={selectedStaff && selectedStaff.profile_image ? selectedStaff?.profile_image : DefaultProfileImg} alt="Admin" />
                  </figure>
                  <h4>{selectedStaff && selectedStaff?.first_name}</h4>
                </div>
                <form onSubmit={(e) => {
                  e.preventDefault(); // Prevent the default form submission behavior
                  formik.handleSubmit(); // Trigger Formik's submit handler
                }}>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      {t("label_password")}
                      <span>*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type={!show === true ? "text" : "password"}
                        className="form-control border-end-0"
                        id="password"
                        placeholder={t("placeholder_password")}
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span
                        className="input-group-text cp restaurant-password-toggle"
                        onClick={() => {
                          handleshow();
                        }}
                      >
                        {!show === true ? <i className="ti ti-eye"></i> : <i className="ti ti-eye-off"></i>}
                      </span>
                    </div>
                    <CustomError name="password" form={formik} className="text-danger" />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    {t("btn_submit")}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
